<h4 *ngIf="modalFunctionHeadline" class="headline">
  {{ modalFunctionHeadline }}
</h4>
<ng-container *ngIf="type === 'tooltip'">
  <div class="more">
    <a
      *ngIf="showIcon"
      (click)="openModal()"
      class="icon__tooltip"
      [title]="videoTitle"
    >
      <hdi-icon [color]="color" [size]="size" [iconName]="'tooltip'"></hdi-icon>
    </a>
    <p [innerHTML]="label"></p>
  </div>
</ng-container>
<ng-container *ngIf="type === 'tooltip_reverse'">
  <div class="more">
    <span>
      <hdi-icon
        *ngIf="secondaryIcon"
        [color]="color"
        [size]="size"
        [iconName]="secondaryIcon"
      ></hdi-icon>
      <p>{{ label }}</p>
      <hdi-badge
        *ngIf="showBadge"
        [type]="BadgeType.CAPSULE"
        [label]="badgeLabel ? badgeLabel : ('Badge' | capitalize)"
      ></hdi-badge>
    </span>
    <a
      *ngIf="showIcon"
      (click)="openModal()"
      class="icon__tooltip"
      [title]="videoTitle"
    >
      <hdi-icon
        [color]="color"
        [size]="size"
        [iconName]="IconTooltip"
      ></hdi-icon>
    </a>
  </div>
</ng-container>
<ng-container *ngIf="type === 'list'">
  <div class="list">
    <p [innerHTML]="modalFunctionLabel"></p>
    <a
      *ngIf="showIcon"
      (click)="openModal()"
      class="icon__list"
      [title]="videoTitle"
    >
      ><hdi-icon [color]="color" [size]="size" [iconName]="IconList"></hdi-icon
    ></a>
  </div>
</ng-container>

<ng-container *ngIf="type === 'video'">
  <div class="video" [class]="videoSizes">
    <hdi-image
      *ngIf="!imageSrc"
      class="video-header-stage__image"
      [src]="placeholderSrc"
      [alt]="imageAlt"
      [title]="imageTitle"
      [lazy]="lazy"
    />
    <hdi-image
      *ngIf="imageSrc"
      class="video__image"
      [src]="imageSrc"
      [alt]="imageAlt"
      [title]="imageTitle"
      [style.objectPosition]="imageObjectPosition"
      [lazy]="lazy"
    />
    <a
      *ngIf="showIcon"
      (click)="openModal()"
      class="icon__video"
      [title]="videoTitle"
    >
      <hdi-button
        [type]="buttonType.ROUNDED_PRIMARY"
        [iconName]="'play'"
      ></hdi-button>
    </a>
  </div>
</ng-container>

<ng-container *ngIf="type === 'video_header_stage'">
  <div class="video-header-stage" [class]="videoSizes">
    <hdi-image
      *ngIf="!imageSrc"
      class="video-header-stage__image"
      [src]="placeholderSrc"
      [alt]="imageAlt"
      [title]="imageTitle"
      [lazy]="lazy"
    />
    <hdi-image
      *ngIf="imageSrc"
      class="video-header-stage__image"
      [src]="imageSrc"
      [alt]="imageAlt"
      [title]="imageTitle"
      [style.objectPosition]="imageObjectPosition"
      [lazy]="lazy"
    />
    <a
      *ngIf="showIcon"
      (click)="openModal()"
      class="icon__video"
      [title]="videoTitle"
    >
      <hdi-button
        [type]="buttonType.ROUNDED_PRIMARY"
        [iconName]="'play'"
      ></hdi-button>
    </a>
  </div>
</ng-container>

<ng-container *ngIf="type === 'expand'">
  <div class="expand">
    <a *ngIf="showIcon" (click)="openModal()" class="icon__expand"
      ><hdi-icon
        [color]="color"
        [size]="size"
        [iconName]="IconExpand"
      ></hdi-icon
    ></a>
  </div>
</ng-container>
